export type FiltroRevision = 'TODOS' | 'COMENTARIOS' | 'RECHAZOS';

interface Props {
  tieneRechazos: boolean;
  tieneComentarios: boolean;
  value: FiltroRevision;
  onChange: (value: FiltroRevision) => void;
}

export function RevisionFilterSelect({ tieneRechazos, tieneComentarios, value, onChange }: Props) {
  if (!tieneRechazos && !tieneComentarios) return null;
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-[11px] font-medium" style={{ color: 'var(--admin-text3)' }}>
        Ver:
      </span>
      <select id="filtro-revision-select" value={value} onChange={(e) => onChange(e.target.value as FiltroRevision)}>
        <option value="TODOS">Vista normal</option>
        {tieneComentarios && <option value="COMENTARIOS">Ver comentarios</option>}
        {tieneRechazos && <option value="RECHAZOS">Ver rechazos</option>}
      </select>
    </div>
  );
}
